import { useTranslation } from 'react-i18next';
import eleve from "../../../img/symbols/eleve.svg";
import leger from "../../../img/symbols/leger.svg";
import faible from "../../../img/symbols/faible.svg";
import modere from "../../../img/symbols/modere.svg";
import tresEleve from "../../../img/symbols/tres-eleve.svg";

/**
 * RiskSymbolsLegends component displays the risk level symbols with their corresponding labels.
 * Shows "Légende :" (non-clickable) followed by "Symboles de risque :" (clickable link to
 * the risk symbols reference page) and the 5 risk level icons.
 *
 * @param {Object} props
 * @param {string} [props.title] - Optional custom link text (defaults to "Symboles de risque :")
 */
const RiskSymbolsLegends = ({ title }) => {
    const { t } = useTranslation('common');

    const legend = [
        { label: t('legends.risk.low'), image: faible },
        { label: t('legends.risk.light'), image: leger },
        { label: t('legends.risk.moderate'), image: modere },
        { label: t('legends.risk.high'), image: eleve },
        { label: t('legends.risk.extremelyHigh'), image: tresEleve }
    ];

    const legendLabel = t('legends.title');                    // "Légende :"
    const riskLinkTitle = title || t('legends.risk.title');    // "Symboles de risque :" by default
    // Strip trailing colon/spaces from the title for the link text
    const riskLinkText = riskLinkTitle.replace(/\s*:\s*$/, '');

    return (
        <div className="flex gap-6 items-center flex-wrap">
            <span className="text-[14px] font-bold text-black">
                {legendLabel}
            </span>
            <span className="text-[14px] font-bold">
                <a
                    href="/symboles-de-risque/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#105235] hover:underline"
                >
                    {riskLinkText}
                </a>
                {' :'}
            </span>
            <div className="flex gap-4 flex-wrap">
                {legend.map((item, index) => (
                    <div key={index} className="flex flex-col gap-2 items-center">
                        <img src={item.image} alt={item.label} className="w-8 h-8" />
                        <span className="text-sm max-w-[90px] text-center">{item.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RiskSymbolsLegends;